import hexPave from './images/hex-pave.jpg';

export const puzzles = [
	{
		"name": "Bubbloid122",
		"description": "A Compy Cube redesigned to be a puzzle with a multi-origin-core.",
		"image": "https://twistypuzzles.com/museum/large/03326-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Bubbloid112",
		"description": "A corner turning cuboid designed to be a puzzle with a multi-origin-core. The second implementation of this concept.",
		"image": "https://twistypuzzles.com/museum/large/03488-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Bubbloid123",
		"description": "A corner turning cuboid designed to be a puzzle with a multi-origin-core. The third implementation of this concept.",
		"image": "https://twistypuzzles.com/museum/large/04913-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Bubbloid233",
		"description": "A corner turning cuboid designed to be a puzzle with a multi-origin-core. The fourth implementation of this concept.",
		"image": "https://twistypuzzles.com/museum/large/04914-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Bubbloid223",
		"description": "A corner turning cuboid designed to be a puzzle with a multi-origin-core. The fifth implementation of this concept.",
		"image": "https://twistypuzzles.com/museum/large/04924-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Bubblism521",
		"description": "A corner turning pentagonal prism designed to be a puzzle with a multi-origin-core. The sixth implementation of this concept.",
		"image": "https://twistypuzzles.com/museum/large/00125-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Augmented Skewb",
		"description": "A Skewb with additional piece but still only two functional layers per axis.",
		"image": "https://twistypuzzles.com/museum/large/06130-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Complex 3x3x3",
		"description": "An implementation of a 8-years-old dream. A 3x3x3 with six additional pieces types known before only through geometry.",
		"image": "https://twistypuzzles.com/museum/large/06777-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Doctor Cube",
		"description": "A Mixup Cube reduced to the slice moves.",
		"image": "https://twistypuzzles.com/museum/large/03070-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Doctor Skewb",
		"description": "A slices-turn-only Mixup Master Skewb. It has 4 possible twists with steps of 30° each.",
		"image": "https://twistypuzzles.com/museum/large/02304-01.jpg",
		"type": "twisty"
	},
	{
		"name": "DoDep Kit",
		"description": "This puzzle succeeds the Neptune DoDep. It allows to implement 680 puzzles with on kit.",
		"image": "https://twistypuzzles.com/museum/large/04893-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Double Circle Real 5x5x5",
		"description": "The Real 5x5x5 => A 5x5x5 with a 3x3x3 inside and twistable.",
		"image": "https://twistypuzzles.com/museum/large/04823-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Double Circle Real 6x6x6",
		"description": "A real 6x6x6, a 6x6x6 where you also have to solve the inner 4x4x4 and the 2x2x2 inside of it.",
		"image": "https://twistypuzzles.com/museum/large/08054-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Dual Skewb",
		"description": "Two skewbs built over each other to implement a rarely seen piece type instead of the non-present traditional faces pieces.",
		"image": "https://twistypuzzles.com/museum/large/07489-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Evil Doppelgänger",
		"description": "A special subvariant of the Multi Gear Cube Kit closely related to the Gear Cube Extreme.",
		"image": "https://twistypuzzles.com/museum/large/04723-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Mercury Uniaxial 3x3x3",
		"description": "A slight modification of the Deep Uniaxial 3x3x3.",
		"image": "https://twistypuzzles.com/museum/large/03297-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Multi Gear Cube Kit",
		"description": "A generalized version of the Paso Doble. It allows all kinds of gearing ratios between opposite sides for all three axis.",
		"image": "https://twistypuzzles.com/museum/large/03509-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Neptune DoDep 3x3x3",
		"description": "The result of a three year old idea. Although it looks like a 5x5x5 there are only two cuts possible for each axis.",
		"image": "https://twistypuzzles.com/museum/large/04775-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Other 4x4x4 (aka Puzzle 19)",
		"description": "Designed to be a 4x4x4 with exposed new theoretical pieces. Although it has 64 pieces it presents itself as a superset of the 3x3x3.",
		"image": "https://twistypuzzles.com/museum/large/06808-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Psi Quantum Entanglement",
		"description": "The successor of the Quantum Entanglement with inverted gearing.",
		"image": "https://twistypuzzles.com/museum/large/07516-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Thorny Cube",
		"description": "A Circle Mixup Cube.",
		"image": "https://twistypuzzles.com/museum/large/04366-01.jpg",
		"type": "twisty"
	},
	{
		"name": "TriQuad",
		"description": "A non truncated version of Bygride-3-4 with different cuts.",
		"image": "https://twistypuzzles.com/museum/large/06809-01.jpg",
		"type": "twisty"
	},
	{
		"name": "Window Real 5x5x5",
		"description": "A 5x5x5 with a 3x3x3 visible inside of it.",
		"image": "https://twistypuzzles.com/museum/large/04899-01.jpg",
		"type": "twisty"
	},
	{
		"name": "XOteric 2x2x2",
		"description": "Looks like a Circle 2x2x2 but is a 2x2x2 with the Triwalls as additional piece types.",
		"image": "https://twistypuzzles.com/museum/large/06814-01.jpg",
		"type": "twisty"
	},
	{
		"name": "WOW5",
		"description": "This puzzle ring won a Jury Honorable Mention in the 2016 Nob Yoshigahara Puzzle Design Competition at IPP36 in Kyoto, Japan",
		"image": "https://puzzleringmaker.com/z_it_WO_9.jpg",
		"type": "ring"
	},
	{
		"name": "WOW5 Lite",
		"description": "The 3D model for WOW5 was tweaked, to make it less wide and a little less thick, then all the sizes were produced by scaling that model, just as was done with WOW5.",
		"image": "https://puzzleringmaker.com/z_it_WOL_9.jpg",
		"type": "ring"
	},
	{
		"name": "WASP",
		"description": "A puzzle ring comprised of six bands while the WOW5 uses five",
		"image": "https://puzzleringmaker.com/z_it_WA.jpg",
		"type": "ring"
	},
	{
		"name": "Three Phase Puzzle Ring",
		"description": "Three Phase is a beginner level 3 band puzzle ring. This is a wrap around design as the weave goes all the way way around the ring.",
		"image": "https://images1.sw-cdn.net/cdn-cgi/image/quality=85,gravity=auto,format=auto,fit=scale-down,width=1920/product/picture/710x528_17567329_9177276_1486336564_1_0.jpg",
		"type": "ring"
	},
	{
		"name": "Untouchable 11 Master Challenge",
		"description": "This is the Untouchable 11 Master Challenge, based on the original Untouchable 11 puzzle by Peter Grabarchuk. The goal is to put these 11 hexominoes within the board so that no two touch each other even at a corner. It has 2 solutions.",
		"image": "https://images1.sw-cdn.net/cdn-cgi/image/quality=85,gravity=auto,format=auto,fit=scale-down,width=1920/product/picture/710x528_234041_487355_1603664649_1_0.jpg",
		"type": "pack"
	},
	{
		"name": "Hazmat Cargo",
		"description": "This is the FDM version of Hazmat Cargo. The goal is to pack the 9 pieces onto the 11x11 board.",
		"image": "https://images.squarespace-cdn.com/content/v1/623fa9ea7b61767894a3bca2/1648485425997-X85KS2NN9QBKXWQD8T2N/IMG_20201009_153137.jpg?format=750w",
		"type": "pack"
	},
	{
		"name": "Social Distancing",
		"description": "This is the FDM version of Social Distancing. Nine pentominos walk into a bar, you need to seat the nine pentominos while following social distancing guidelines.",
		"image": "https://images.squarespace-cdn.com/content/v1/623fa9ea7b61767894a3bca2/1648485752292-FLYT38TDGLGX0MCGWT4C/IMG_20201011_142310.jpg?format=750w",
		"type": "pack"
	},
	{
		"name": "Hex-Pave",
		"description": "Hex-Pave has 15 hexagons, each with a unique combination of 1 to 3 units of length per side and equal angles. Tiles are sorted by color into matching symmetry groups. All but one have mirror symmetry; the oddball is rotational. Its basic assembly is a regular hexagon; 11 other shapes of 6 triangles exist",
		"image": hexPave,
		"type": "pack"
	}
]